import styled from 'styled-components';
import BenefitsIconSvg from './benefits-tick.svg';

const BenefitsIcon = styled(BenefitsIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || '#647a97'};
  
`;

export default BenefitsIcon;

